// Whether the entry before this one in the browser's history is one of the app's own
// pages. The Navigation API lists only this site's entries; without it, any entry counts.
const canGoBackInApp = (history) => {
  const canGoBack = window.navigation?.canGoBack;
  return typeof canGoBack === "boolean" ? canGoBack : history.length > 1;
};

// For the app's own Back controls (the header's arrow, the "Go back" buttons). The page
// the app opened on has no page of the app's behind it: Android reopens the last page as
// the only entry of a new WebView after it recreates the activity, and a shared link opens
// one in a new tab. history.goBack() did nothing there, or left the site, so this goes Home.
export const goBackOrHome = (history) => {
  if (canGoBackInApp(history)) history.goBack();
  else history.replace("/");
};
